export function isInvalidEmail(value) {
    return value && !value.match(/[\w\-\.+]+@([\w-]+\.)+[\w-]{2,63}$/g); // eslint-disable-line
}

export function isUrl(value) {
    return value && value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:?#[\]@!\$&'\(\)\*\+\/,;=.]+$/); // eslint-disable-line
}

export function isEmail(value) {
    return value && value.match(/[\w-\.+]+@([\w-]+\.)+[\w-]{2,63}$/g); // eslint-disable-line
}
